import React, { useContext } from "react";
import {
    SettingsDeviceModeBg,
    SettingsDeviceModeBtnContainer,
    SettingsDeviceModeMonBtn,
    SettingsDeviceModeTelBtn,
} from "./SettingsDeviceMode.elements";

import { AppContext } from "../../components/States/AppContext";
import { PopUpBox } from "../PopUps/PopUp.elements";

const SettingsDeviceMode = ({ setting }) => {

  const { state, setState } = useContext(AppContext);
  

  const handleClickTelemetry = () => {
    
    setState(prevState =>  ({...prevState, telemetry: true}));
    
  }
  
  const handleClickMonitor = () => {
    
    setState(prevState =>  ({...prevState, telemetry: false}));
    
  }

  return (
    <>
     <SettingsDeviceModeBg>
     <SettingsDeviceModeBtnContainer>
          <SettingsDeviceModeTelBtn 
          onClick={handleClickTelemetry}
          active = {state.telemetry}
          >Telemetry</SettingsDeviceModeTelBtn>
          <SettingsDeviceModeMonBtn 
          onClick={handleClickMonitor}
          active = {state.telemetry}

          >Monitor</SettingsDeviceModeMonBtn>
        </SettingsDeviceModeBtnContainer>
     </SettingsDeviceModeBg>

  
    </>
  );
};

export default SettingsDeviceMode;
